export default __webpack_public_path__ + "static/media/Icon-list-grey.9ac6a677.svg";